import { routes } from "@/consts";
import { getData } from "@/lib/utils";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const accesToken = getData("tokens")?.accessToken;
  return (
    <footer className="bg-white border-t text-black py-10 mt-10 px-2">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-1/3 mb-8 md:mb-0 ">
            <h1 className="ml-4 text-3xl font-extrabold  bg-clip-text bg-gradient-to-r from-black to-gray-400">
              Med<span className="text-black">e</span>x
            </h1>
            <p className="text-gray-700 mt-4 xl:w-96">
              {t("general.companyDescription")}
            </p>
          </div>

          {/* Quick Links */}
          <div className="w-full md:w-1/3 mb-8 md:mb-0 px-3">
            <h3 className="text-lg font-semibold mb-4">
              {t("general.quickLinks")}
            </h3>
            <ul className="text-gray-700">
              {!accesToken ? (
                <li className="mb-2">
                  <Link to={routes.register} className="hover:text-purple-700">
                    {t("actions.registerAsSeller")}
                  </Link>
                </li>
              ) : (
                ""
              )}
              <li className="mb-2">
                <Link to={routes.aboutUs} className="hover:text-purple-700">
                  {t("general.aboutUs")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="w-full md:w-1/3">
            <h3 className="text-lg font-semibold mb-4">
              {t("actions.contactUs")}
            </h3>
            <p className="text-gray-700 mb-2">
              <Link
                to="mailto:support@medex2b.com"
                className="hover:text-purple-500"
              >
                support@medex2b.com
              </Link>
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 text-center text-gray-500">
          <p>{t("general.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
